import React from 'react';
import {WeaLocaleProvider, WeaAlertPage} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

const WeaPortalAlert = (props) => {
    if (props.status === -1) {
        return (
            <div style={{position: 'relative', width: '100%', height: '100%', backgroundColor: '#fff'}}>
                <WeaAlertPage>
                    <div style={{color: '#000'}}>{getLabel(2012, "对不起，您暂时没有权限！")}</div>
                </WeaAlertPage>
            </div>
        );
    } else {
        return <div></div>;
    }
};

export default WeaPortalAlert;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-portal-alert/index.js